import React, { useEffect } from "react";
import { CheckCircle2, Mail, Phone, ShieldCheck } from "lucide-react";
import Eyebrow from "@/components/Eyebrow";

const GHL_SCRIPT_SRC = "https://links.usabookkeepingsolutionsllc.com/js/form_embed.js";

export default function Contact() {
  // Load the GoHighLevel form_embed.js once when this page mounts
  useEffect(() => {
    const existing = document.querySelector(`script[src="${GHL_SCRIPT_SRC}"]`);
    if (existing) return;
    const s = document.createElement("script");
    s.src = GHL_SCRIPT_SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div data-testid="contact-page">
      <section className="container-editorial py-20 md:py-28 rule-bottom" data-testid="contact-header">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-8">
            <Eyebrow>Request, Financial Review</Eyebrow>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1] text-[#0C1D36] mt-6">
              Let's walk through your books, <em className="text-[#BA1A1A] not-italic">together</em>.
            </h1>
          </div>
          <div className="md:col-span-4 md:pt-10">
            <p className="text-lg text-[#0C1D36]/80">
              No pitch. No pressure. A clean, honest review of where things are strong and
              where exposure exists.
            </p>
          </div>
        </div>
      </section>

      <section className="container-editorial py-20 md:py-24" data-testid="contact-body">
        <div className="grid md:grid-cols-12 gap-12 lg:gap-20">
          {/* Left, sidebar */}
          <div className="md:col-span-4 md:border-r md:border-[#0C1D36]/12 md:pr-10">
            <div className="sticky top-28 space-y-10">
              <div>
                <Eyebrow>Why Firms Reach Out</Eyebrow>
                <ul className="mt-6 space-y-4 text-[#0C1D36]/85">
                  {["Trust account concerns", "Messy or stale books", "Preparing for an audit", "Switching bookkeepers", "Scaling the firm"].map((r) => (
                    <li key={r} className="flex items-start gap-3">
                      <CheckCircle2 className="w-4 h-4 mt-1 text-[#BA1A1A]" />
                      <span>{r}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rule-top pt-8">
                <Eyebrow muted>Direct</Eyebrow>
                <ul className="mt-5 space-y-3 text-sm text-[#0C1D36]/85">
                  <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#BA1A1A]" /> info@usabookkeepingllc.com</li>
                  <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#BA1A1A]" /> +1 561-621-1495</li>
                </ul>
              </div>

              <div className="rule-top pt-8 text-xs text-[#4B5563] flex items-start gap-2">
                <ShieldCheck className="w-4 h-4 mt-0.5 text-[#0C1D36]" />
                <span>Your information is treated as confidential and reviewed only by our engagement team.</span>
              </div>
            </div>
          </div>

          {/* Right, GHL embedded form */}
          <div className="md:col-span-8" data-testid="ghl-form-wrapper">
            <iframe
              src="https://links.usabookkeepingsolutionsllc.com/widget/form/7f2p62DplJfyYGv9TSLA"
              style={{ width: "100%", minHeight: "920px", border: "none", borderRadius: 0, background: "#FDFBF7" }}
              id="inline-7f2p62DplJfyYGv9TSLA"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="Request A Financial Review"
              data-height="896"
              data-layout-iframe-id="inline-7f2p62DplJfyYGv9TSLA"
              data-form-id="7f2p62DplJfyYGv9TSLA"
              title="Request A Financial Review"
              data-testid="ghl-form-iframe"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
